import { descriptionUI } from 'platform/forms-system/src/js/web-component-patterns';
import FileUploadDescription from '../../components/FormDescriptions/FileUploadDescription';
import {
  attachmentSchema,
  attachmentUI,
  DEFAULT_TITLE_OPTS,
  titleWithFormDataUI,
} from '../../definitions';
import content from '../../locales/en/content.json';
import { ATTACHMENT_IDS } from '../../utils/constants';

const TITLE_TEXT = content['health-insurance--card-upload-title'];
const DESC_TEXT = content['health-insurance--card-upload-description'];

const INPUT_LABELS = {
  cardFront: content['health-insurance--card-upload-label--front'],
  cardBack: content['health-insurance--card-upload-label--back'],
};
const HINT_TEXT = content['attachments--hint-text'];

export default {
  uiSchema: {
    ...titleWithFormDataUI(TITLE_TEXT, DESC_TEXT, DEFAULT_TITLE_OPTS.insurance),
    ...descriptionUI(FileUploadDescription),
    insuranceCardFront: attachmentUI({
      title: INPUT_LABELS.cardFront,
      hint: HINT_TEXT,
      attachmentId: ATTACHMENT_IDS.ohiCardFront,
    }),
    insuranceCardBack: attachmentUI({
      title: INPUT_LABELS.cardBack,
      hint: HINT_TEXT,
      attachmentId: ATTACHMENT_IDS.ohiCardBack,
    }),
  },
  schema: {
    type: 'object',
    required: ['insuranceCardFront', 'insuranceCardBack'],
    properties: {
      insuranceCardFront: attachmentSchema,
      insuranceCardBack: attachmentSchema,
    },
  },
};
